// @flow

import React from 'react';
import type { ComponentType } from 'react';
import { connect } from 'react-redux';
import parseMacros from './helpers/parseMacros';
import { type Macro } from '../../helpers/macros';

type InjectedProps = {|
  url: string,
|};

const withMacrosButton = <Props: {}>(
  WrappedComponent: ComponentType<*>,
  macros: Array<Macro> = [],
): ComponentType<$Diff<{| ...Props, url: string |}, InjectedProps>> => {
  type StateProps = {|
    parse: Function,
  |};

  const mapStateToProps = (state): StateProps => ({
    parse: parseMacros(part => (typeof part === 'function' ? part(state) : part)),
  });

  const ComponentToConnect = ({
    parse,
    url,
    ...props
  }: InjectedProps & StateProps) => <WrappedComponent {...props} url={parse(url, macros)} />;

  return connect<any, InjectedProps, StateProps, any, any, any>(
    mapStateToProps,
  )(ComponentToConnect);
};

export default withMacrosButton;
